module.exports = __webpack_public_path__ + "static/media/check-circle-premium.5d7d5647.svg";